import { useTranslation } from 'react-i18next';
import styles from './PrivacyPolicyCard.module.css';
import Logo from '@/components/UI/Logo';

interface PrivacyPolicyCardProps {
	displayLogo: boolean;
}

const PrivacyPolicyCard = (props: PrivacyPolicyCardProps) => {
	const { t } = useTranslation();

	return (
		<>
			{props.displayLogo && (
				<div className={styles.privacy_header}>
					<Logo className={styles.logo} onClick={() => {}} />
				</div>
			)}

			<div className={styles.privacy_content}>
				{/* Introduzione */}
				<section>
					<h1>{t('privacyPolicy.intro.title')}</h1>
					<p>{t('privacyPolicy.intro.descr')}</p>
				</section>

				<section>
					<h3>{t('privacyPolicy.intro.subintro.title')}</h3>
					<p>{t('privacyPolicy.intro.subintro.descr')}</p>
					<ul>
						<li>{t('privacyPolicy.intro.subintro.dottedList1')}</li>
						<li>{t('privacyPolicy.intro.subintro.dottedList2')}</li>
						<li>{t('privacyPolicy.intro.subintro.dottedList3')}</li>
						<li>{t('privacyPolicy.intro.subintro.dottedList4')}</li>
						<li>{t('privacyPolicy.intro.subintro.dottedList5')}</li>
					</ul>
					<p>{t('privacyPolicy.intro.subintro.descr2')}</p>
				</section>

				<br />
				<hr />
				{/* Contratto di procacciatore d'affari occasionale  */}
				<section>
					<h1>{t('privacyPolicy.contract.title')}</h1>
					<p>{t('privacyPolicy.contract.descr')}</p>
				</section>

				<section>
					<h3>{t('privacyPolicy.contract.sub.title')}</h3>
					<ol>
						<li>{t('privacyPolicy.contract.sub.nrList1')}</li>
						<li>{t('privacyPolicy.contract.sub.nrList2')}</li>
						<li>{t('privacyPolicy.contract.sub.nrList3')}</li>
						<li>{t('privacyPolicy.contract.sub.nrList4')}</li>
						<li>{t('privacyPolicy.contract.sub.nrList5')}</li>
						<li>{t('privacyPolicy.contract.sub.nrList6')}</li>
						<li>{t('privacyPolicy.contract.sub.nrList7')}</li>
						<li>{t('privacyPolicy.contract.sub.nrList8')}</li>
						<li>{t('privacyPolicy.contract.sub.nrList9')}</li>
					</ol>
					<p>{t('privacyPolicy.contract.sub.descr2')}</p>
				</section>

				<br />
				<br />

				<hr />
				{/* Termini e condizioni  */}
				<section>
					<h1>{t('privacyPolicy.T&C.termsSectionTitle')}</h1>
				</section>

				{/* Punto 1 */}
				<section>
					<h2>{t('privacyPolicy.T&C.regulation.point1.title1')}</h2>
					<h3>{t('privacyPolicy.T&C.regulation.point1.paragraph1.title')}</h3>
					<ol>
						<li>{t('privacyPolicy.T&C.regulation.point1.paragraph1.nrList1')}</li>
						<li>{t('privacyPolicy.T&C.regulation.point1.paragraph1.nrList2')}</li>
					</ol>
				</section>

				<section>
					<h3>{t('privacyPolicy.T&C.regulation.point1.paragraph2.title')}</h3>
					<ol>
						<li>{t('privacyPolicy.T&C.regulation.point1.paragraph2.nrList1')}</li>
						<li>{t('privacyPolicy.T&C.regulation.point1.paragraph2.nrList2')}</li>
						<li>{t('privacyPolicy.T&C.regulation.point1.paragraph2.nrList3')}</li>
					</ol>
				</section>

				<section>
					<h3>{t('privacyPolicy.T&C.regulation.point1.paragraph3.title')}</h3>
					<ol>
						<li>{t('privacyPolicy.T&C.regulation.point1.paragraph3.nrList1')}</li>
						<li>{t('privacyPolicy.T&C.regulation.point1.paragraph3.nrList2')}</li>
					</ol>
				</section>

				<section>
					<h3>{t('privacyPolicy.T&C.regulation.point1.paragraph4.title')}</h3>
					<ol>
						<li>{t('privacyPolicy.T&C.regulation.point1.paragraph4.nrList1')}</li>
						<li>{t('privacyPolicy.T&C.regulation.point1.paragraph4.nrList2')}</li>
					</ol>
				</section>

				{/* Punto 2 */}
				<section>
					<h2>{t('privacyPolicy.T&C.regulation.point2.title2')}</h2>
					<h3>{t('privacyPolicy.T&C.regulation.point2.paragraph1.title')}</h3>
					<ol>
						<li>{t('privacyPolicy.T&C.regulation.point2.paragraph1.nrList1')}</li>
						<li>{t('privacyPolicy.T&C.regulation.point2.paragraph1.nrList2')}</li>
						<li>{t('privacyPolicy.T&C.regulation.point2.paragraph1.nrList3')}</li>
					</ol>
				</section>

				<section>
					<h3>{t('privacyPolicy.T&C.regulation.point2.paragraph2.title')}</h3>
					<ol>
						<li>{t('privacyPolicy.T&C.regulation.point2.paragraph2.nrList1')}</li>
						<ul>
							<li>{t('privacyPolicy.T&C.regulation.point2.paragraph2.nrList1_1')}</li>
							<li>{t('privacyPolicy.T&C.regulation.point2.paragraph2.nrList1_2')}</li>
						</ul>
						<li>{t('privacyPolicy.T&C.regulation.point2.paragraph2.nrList2')}</li>
					</ol>
				</section>

				<section>
					<h3>{t('privacyPolicy.T&C.regulation.point2.paragraph3.title')}</h3>
					<ol>
						<li>{t('privacyPolicy.T&C.regulation.point2.paragraph3.nrList1')}</li>
						<li>{t('privacyPolicy.T&C.regulation.point2.paragraph3.nrList2')}</li>
					</ol>
				</section>

				<section>
					<h3>{t('privacyPolicy.T&C.regulation.point2.paragraph4.title')}</h3>
					<ol>
						<li>{t('privacyPolicy.T&C.regulation.point2.paragraph4.nrList1')}</li>
						<li>{t('privacyPolicy.T&C.regulation.point2.paragraph4.nrList2')}</li>
					</ol>
				</section>

				{/* Punto 3 */}
				<section>
					<h2>{t('privacyPolicy.T&C.regulation.point3.title3')}</h2>
					<h3>{t('privacyPolicy.T&C.regulation.point3.paragraph1.title')}</h3>
					<ol>
						<li>{t('privacyPolicy.T&C.regulation.point3.paragraph1.nrList1')}</li>
						<li>{t('privacyPolicy.T&C.regulation.point3.paragraph1.nrList2')}</li>
					</ol>
				</section>

				<section>
					<h3>{t('privacyPolicy.T&C.regulation.point3.paragraph2.title')}</h3>
					<ol>
						<li>{t('privacyPolicy.T&C.regulation.point3.paragraph2.nrList1')}</li>
						<li>{t('privacyPolicy.T&C.regulation.point3.paragraph2.nrList2')}</li>
					</ol>
				</section>

				<section>
					<h3>{t('privacyPolicy.T&C.regulation.point3.paragraph3.title')}</h3>
					<ol>
						<li>{t('privacyPolicy.T&C.regulation.point3.paragraph3.nrList1')}</li>
						<li>{t('privacyPolicy.T&C.regulation.point3.paragraph3.nrList2')}</li>
						<li>{t('privacyPolicy.T&C.regulation.point3.paragraph3.nrList3')}</li>
					</ol>
				</section>

				<section>
					<h3>{t('privacyPolicy.T&C.regulation.point3.paragraph4.title')}</h3>
					<ol>
						<li>{t('privacyPolicy.T&C.regulation.point3.paragraph4.nrList1')}</li>
						<ul>
							<li>{t('privacyPolicy.T&C.regulation.point3.paragraph4.nrList1_1')}</li>
							<li>{t('privacyPolicy.T&C.regulation.point3.paragraph4.nrList1_2')}</li>
						</ul>
					</ol>
				</section>

				<br />
				<br />
				<hr />
				{/* Sezione PRIVACY POLICY */}
				<h1>{t('privacyPolicy.pp.privacySectionTitle')}</h1>

				<section>
					<h3>{t('privacyPolicy.pp.referralContract.title')}</h3>
					<p>{t('privacyPolicy.pp.referralContract.descr')}</p>
					<h5>{t('privacyPolicy.pp.referralContract.preamble.title')}</h5>
					<ul>
						<li>{t('privacyPolicy.pp.referralContract.preamble.par1')}</li>
						<li>{t('privacyPolicy.pp.referralContract.preamble.par2')}</li>
						<li>{t('privacyPolicy.pp.referralContract.preamble.par3')}</li>
						<li>{t('privacyPolicy.pp.referralContract.preamble.par4')}</li>
					</ul>
					<h5>{t('privacyPolicy.pp.referralContract.articles.preamble')}</h5>
				</section>

				<section>
					<h4>{t('privacyPolicy.pp.referralContract.articles.art1.title')}</h4>
					<p>{t('privacyPolicy.pp.referralContract.articles.art1.description')}</p>
					<p>{t('privacyPolicy.pp.referralContract.articles.art1.dataIncluded')}</p>
					<ul>
						<li>{t('privacyPolicy.pp.referralContract.articles.art1.dataIncluded1')}</li>
						<li>{t('privacyPolicy.pp.referralContract.articles.art1.dataIncluded2')}</li>
						<li>{t('privacyPolicy.pp.referralContract.articles.art1.dataIncluded3')}</li>
						<li>{t('privacyPolicy.pp.referralContract.articles.art1.dataIncluded4')}</li>
						<li>{t('privacyPolicy.pp.referralContract.articles.art1.dataIncluded5')}</li>
						<li>{t('privacyPolicy.pp.referralContract.articles.art1.dataIncluded6')}</li>
						<li>{t('privacyPolicy.pp.referralContract.articles.art1.dataIncluded7')}</li>
						<li>{t('privacyPolicy.pp.referralContract.articles.art1.dataIncluded8')}</li>
						<li>{t('privacyPolicy.pp.referralContract.articles.art1.dataIncluded9')}</li>
						<li>{t('privacyPolicy.pp.referralContract.articles.art1.dataIncluded10')}</li>
						<li>{t('privacyPolicy.pp.referralContract.articles.art1.dataIncluded11')}</li>
					</ul>
				</section>

				<section>
					<h4>{t('privacyPolicy.pp.referralContract.articles.art2.title')}</h4>
					<p>{t('privacyPolicy.pp.referralContract.articles.art2.description')}</p>
					<p>{t('privacyPolicy.pp.referralContract.articles.art2.description2')}</p>
				</section>

				<section>
					<h4>{t('privacyPolicy.pp.referralContract.articles.art3.title')}</h4>
					<p>{t('privacyPolicy.pp.referralContract.articles.art3.description')}</p>
					<p>{t('privacyPolicy.pp.referralContract.articles.art3.description2')}</p>
					<p>{t('privacyPolicy.pp.referralContract.articles.art3.description3')}</p>
					<p>{t('privacyPolicy.pp.referralContract.articles.art3.description4')}</p>
				</section>

				<section>
					<h4>{t('privacyPolicy.pp.referralContract.articles.art4.title')}</h4>
					<p>{t('privacyPolicy.pp.referralContract.articles.art4.description')}</p>
				</section>

				<section>
					<h4>{t('privacyPolicy.pp.referralContract.articles.art5.title')}</h4>
					<p>{t('privacyPolicy.pp.referralContract.articles.art5.description')}</p>
				</section>

				<section>
					<h4>{t('privacyPolicy.pp.referralContract.articles.art6.title')}</h4>
					<p>{t('privacyPolicy.pp.referralContract.articles.art6.description')}</p>
					<p>{t('privacyPolicy.pp.referralContract.articles.art6.description2')}</p>
				</section>

				<section>
					<h4>{t('privacyPolicy.pp.referralContract.articles.art7.title')}</h4>
					<p>{t('privacyPolicy.pp.referralContract.articles.art7.description')}</p>
				</section>

				<section>
					<h4>{t('privacyPolicy.pp.referralContract.articles.art8.title')}</h4>
					<p>{t('privacyPolicy.pp.referralContract.articles.art8.prohibited')}</p>
					<ul>
						<li>{t('privacyPolicy.pp.referralContract.articles.art8.prohibited2')}</li>
						<li>{t('privacyPolicy.pp.referralContract.articles.art8.prohibited3')}</li>
						<li>{t('privacyPolicy.pp.referralContract.articles.art8.prohibited4')}</li>
					</ul>
					<p>{t('privacyPolicy.pp.referralContract.articles.art8.consequence')}</p>
				</section>

				<section>
					<h4>{t('privacyPolicy.pp.referralContract.articles.art9.title')}</h4>
					<p>{t('privacyPolicy.pp.referralContract.articles.art9.description')}</p>
					<ul>
						<li>{t('privacyPolicy.pp.referralContract.articles.art9.description2')}</li>
						<li>{t('privacyPolicy.pp.referralContract.articles.art9.description3')}</li>
						<li>{t('privacyPolicy.pp.referralContract.articles.art9.description4')}</li>
						<li>{t('privacyPolicy.pp.referralContract.articles.art9.description5')}</li>
					</ul>
					<p>{t('privacyPolicy.pp.referralContract.articles.art9.description6')}</p>
				</section>

				<section>
					<h4>{t('privacyPolicy.pp.referralContract.articles.art10.title')}</h4>
					<p>{t('privacyPolicy.pp.referralContract.articles.art10.description')}</p>
					<ul>
						<li>{t('privacyPolicy.pp.referralContract.articles.art10.description2')}</li>
						<li>{t('privacyPolicy.pp.referralContract.articles.art10.description3')}</li>
						<li>{t('privacyPolicy.pp.referralContract.articles.art10.description4')}</li>
					</ul>
					<p>{t('privacyPolicy.pp.referralContract.articles.art10.description5')}</p>
				</section>

				<section>
					<h4>{t('privacyPolicy.pp.referralContract.articles.art11.title')}</h4>
					<p>{t('privacyPolicy.pp.referralContract.articles.art11.description')}</p>
					<p>{t('privacyPolicy.pp.referralContract.articles.art11.description2')}</p>
				</section>
			</div>
		</>
	);
};

export default PrivacyPolicyCard;
